import * as XLSX from 'xlsx';

const OBJECT_ID_RE = /^[0-9a-fA-F]{24}$/;

export function parseAdIdsFromText(raw: string): { ids: string[]; invalidCount: number } {
  const tokens = raw.split(/[\s,]+/).map(s => s.trim()).filter(Boolean);
  const seen = new Set<string>();
  const ids: string[] = [];
  let invalidCount = 0;
  for (const t of tokens) {
    if (OBJECT_ID_RE.test(t)) {
      if (!seen.has(t)) {
        seen.add(t);
        ids.push(t);
      }
    } else {
      invalidCount++;
    }
  }
  return { ids, invalidCount };
}

export async function parseAdIdsFromXlsx(file: File): Promise<{ ids: string[] }> {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(new Uint8Array(buf), { type: 'array' });
  const cells: string[] = [];
  for (const name of wb.SheetNames) {
    const sheet = wb.Sheets[name];
    if (!sheet) continue;
    const rows = XLSX.utils.sheet_to_json<(string | number | boolean | null | undefined)[]>(sheet, { header: 1 });
    for (const row of rows) {
      if (!Array.isArray(row)) continue;
      for (const cell of row) {
        if (cell == null || cell === '') continue;
        cells.push(String(cell));
      }
    }
  }
  return parseAdIdsFromText(cells.join(' '));
}
